/*

Ashraf 11/19/2022 2700912712 Implemented Notes Functionality
Raghu 11/28/2022 2700912712 Table footer fixes
kavya9reddy 11/30/2022 2700912712 Added user defined notes in formula rule
kavya9reddy 11/30/2022 2700912712 integrated payload
Ravi 12/08/2022 2700912712 Fixed Table size
Akhila 12/09/2022 2700912712 Added form Notes
Ashraf 12/09/2022 2700912712 fixed notes reset issue
Dilip 12/12/2022 2700912712 changed tooltip
kavyareddy 12/15/2022 2700912712 Added role disable condition
Ashraf 12/19/2022 2700912712 fixed notes search page break
kavyareddy 12/20/2022 2700912712 Added dropdown for createdBy and noteType
//Raghu 12/26/2022 2700912712 Removed Dialog Component
Dilip 02/20/2023 3225736869 added created by payload change
Dilip 02/21/2023 3225736869 added created by payload change
Raghu 02/28/2023 3225736869 fixed alignments
Akhila 06/07/2023 3225736869 added breadcrum code and description
Dilip-pds 10/19/2023 3225736869 fixed created by dropdown issue
Gireesh 15-12-2023 3225736869 updated payload
*/

import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Button, Grid} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
// import {
//   postSystemNotes,
//   ResetMessage,
//   resetNotesStatus,
// } from "../../../../../redux/reducers/BRE/AddReportMaster";
// import AddUserDefinedNotes from "../../../../components/AddUserDefinedNotes";
import AddUserDefinedNotes from '../../../../../components/AddUserDefinedNotes';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import DialogBox from '../../../../../components/DialogBox';
import {
  systempostNotesInformation,
  resetPostStatus,
  systemNotesResetToast,
} from '../../../../../redux/reducers/BRE/SystemNotes';
import SearchNotesForm from '../../../../../components/SearchNotes/searchNotesForm';

const FormulaNote = ({
  open,
  dialogClose,
  title,
  maxWidth,
  value,
  handleSubmit,
  condition,
  buttonCondition,
  formulaCodeData,
}) => {
  const tableRef = createRef();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();

  const {systemnotesStatus, systemisLoading} = useSelector(({systemNotes}) => systemNotes);
  useEffect(() => {
    if (systemnotesStatus === 200) {
      tableRef.current.onQueryChange();
      handleDialogClose();

      dispatch(resetPostStatus());
      setTimeout(() => {
        dispatch(systemNotesResetToast());
      }, 3000);
    }
  }, [systemnotesStatus]);
  const dispatchRecordFormatSystemNotes = (data) => {
    dispatch(
      systempostNotesInformation({
        code: formulaCodeData ? formulaCodeData?.code : '',
        noteText: data,
        reportId: formulaCodeData?.groupId ? formulaCodeData?.groupId : 0,
      }),
    );
  };
  let transcription = '';
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        minWidth: '500px',
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
    {
      title: 'Created By',
      field: 'userId',
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
  ];

  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);

  const reportMasterDisableAdd = roleData?.window?.['Report Master']?.['RM'];
  const roleDataAccessDc = roleData?.window?.['Data Calculations']?.['DC'];

  useEffect(() => {
    if (submit) {
      tableRef?.current?.onQueryChange();
    }
  }, [submit, searchData]);

  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  return (
    <>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            isLoading={systemisLoading}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            reportMasterDisableAdd={reportMasterDisableAdd}
          />
        )}
      </DialogBox>
      <Grid className="system-notes-dialog">
        <SearchNotesForm
          setSearchData={setSearchData}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          formulaCodeData={formulaCodeData}
          moduleName={'datacalculation'}
        />
        <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `rules/find/all/notes`;
                const bodyObj = {
                  code: formulaCodeData?.code,
                  frameworkId: formulaCodeData?.groupId ? formulaCodeData?.groupId : 0,
                  limit: rows,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  search: '',
                  noteDate: searchData?.noteDate ?
                    moment(searchData?.noteDate).format('MM/DD/YYYY') :
                    '',
                  noteText: searchData?.noteText ? searchData?.noteText : '',
                  noteType: searchData?.noteType?.key ? searchData?.noteType?.key : '',
                  createdBy: searchData?.createdBy?.userLoginName ? searchData?.createdBy?.userLoginName : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!formulaCodeData?.code) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObjects.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbar: true,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer new-standard-textfields">
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    labelRowsPerPage={'Rows per screen:'}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            actions={[
              {
                icon: () => (
                  <div className="new-standard-textfields">
                    <Button
                      variant="outlined"
                      className="search-btn"
                      disabled={!roleDataAccessDc?.add}
                    >
                      <AddIcon /> Add
                    </Button>
                  </div>
                ),
                disabled: !roleDataAccessDc?.add,
                isFreeAction: true,
                onClick: () => handleSelectedNotesOption(),
              },
            ]}
          />
        </div>
      </Grid>
    </>
  );
};

export default FormulaNote;
